// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.input-label {
    font-size: 1.0625rem;
    font-weight: 700;
    --tw-text-opacity: 1;
    color: rgb(73 89 105 / var(--tw-text-opacity, 1));
}

.input-field {
    margin-top: 0.125rem;
    width: 100%;
    border-radius: 0.5rem;
    border-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(235 232 232 / var(--tw-border-opacity, 1));
    padding-left: 1rem;
    padding-right: 1rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    font-size: 1.0625rem;
    font-weight: 500;
    color: ;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 300ms;
}

.input-field:focus {
    border-color: ;
    outline: 2px solid transparent;
    outline-offset: 2px;
}

@media (min-width: 1400px) {

    .input-field {
        border-radius: 0.75rem;
        border-width: 0.0625rem;
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
    }
}

/* date picker input */
.input-date-field {
    border-radius: 0.75rem;
    border-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(235 232 232 / var(--tw-border-opacity, 1));
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    padding-inline-start: 1rem;
    font-size: 1rem;
    font-weight: 500;
    color: ;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 300ms;
}
.input-date-field:focus {
    border-color: ;
    --tw-ring-color: ;
}
@media (min-width: 1400px) {

    .input-date-field {
        border-radius: 0.75rem;
        border-width: 2px;
        padding-top: 0.625rem;
        padding-bottom: 0.625rem;
        font-size: 1.0625rem;
    }
}

.input-prefix-content {
    border-right-width: 2px;
    --tw-border-opacity: 1;
    border-color: rgb(235 232 232 / var(--tw-border-opacity, 1));
    padding-right: 0.75rem;
    font-size: 1.0625rem;
    font-weight: 500;
    --tw-text-opacity: 1;
    color: rgb(73 89 105 / var(--tw-text-opacity, 1));
}

.input-with-prefix {
    display: block;
    width: 100%;
    border-radius: 0.5rem;
    border-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(235 232 232 / var(--tw-border-opacity, 1));
    padding: 0.75rem;
    padding-inline-start: 5rem;
    font-size: 1.0625rem;
    font-weight: 500;
    color: ;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 300ms;
}

.input-with-prefix:focus {
    border-color: ;
    --tw-ring-color: ;
}

@media (min-width: 1400px) {

    .input-with-prefix {
        border-radius: 0.75rem;
        padding: 1rem;
        padding-inline-start: 5rem;
    }
}

.checkbox-label {
    font-size: 1.0625rem;
    font-weight: 600;
    --tw-text-opacity: 1;
    color: rgb(73 89 105 / var(--tw-text-opacity, 1));
}

.checkbox {
    height: 1.25rem;
    width: 1.25rem;
    cursor: pointer;
    border-radius: 0.375rem;
    border-width: 2px;
    border-color: ;
    background-color: ;
}

@media (min-width: 1400px) {

    .checkbox {
        height: 1.5rem;
        width: 1.5rem;
    }
}

.prefix-icon {
    pointer-events: none;
    position: absolute;
    top: 0px;
    bottom: 0px;
    inset-inline-start: 0px;
    display: flex;
    align-items: center;
    padding-inline-start: 1.25rem;
}

@media (min-width: 1400px) {

    .prefix-icon {
        padding-inline-start: 1.5rem;
    }
}

.input-error {
    --tw-border-opacity: 1;
    border-color: rgb(231 37 21 / var(--tw-border-opacity, 1));
}

@media (min-width: 1400px) {

    .input-error {
        border-width: 2px;
    }
}

.input-prefix-error {
    border-radius: 0.5rem;
    border-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(231 37 21 / var(--tw-border-opacity, 1));
}

@media (min-width: 1400px) {

    .input-prefix-error {
        border-radius: 0.75rem;
        border-width: 2px;
    }
}

.error-msg {
    font-size: 0.813rem;
    font-weight: 600;
    --tw-text-opacity: 1;
    color: rgb(231 37 21 / var(--tw-text-opacity, 1));
}

.input-suffix {
    position: absolute;
    top: 0px;
    bottom: 0px;
    right: 0.75rem;
    display: flex;
    align-items: center;
}

.search-input {
    display: block;
    width: 100%;
    border-radius: 0.625rem;
    border-width: 0.0625rem;
    border-color: ;
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
    padding: 0.5rem;
    padding-inline-start: 2.75rem;
    font-size: 1.0625rem;
    font-weight: 600;
    letter-spacing: 0.025em;
}

.search-input::placeholder {
    color: ;
}

.search-input:focus {
    border-color: ;
    outline: 2px solid transparent;
    outline-offset: 2px;
    --tw-ring-color: ;
}

@media (min-width: 1400px) {

    .search-input {
        border-radius: 0.75rem;
        border-width: 2px;
        padding-inline-start: 3.5rem;
    }
}

.select-field {
    cursor: pointer;
    border-radius: 0.625rem;
    border-width: 0.0625rem;
    --tw-border-opacity: 1;
    border-color: rgb(235 232 232 / var(--tw-border-opacity, 1));
    padding-left: 1rem;
    padding-right: 1rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    font-size: 0.938rem;
    font-weight: 500;
    --tw-text-opacity: 1;
    color: rgb(73 89 105 / var(--tw-text-opacity, 1));
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 300ms;
}

.select-field:focus {
    --tw-border-opacity: 1;
    border-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(0 0 0 / var(--tw-ring-opacity, 1));
}

@media (min-width: 1400px) {

    .select-field {
        border-width: 2px;
        padding-top: 0.625rem;
        padding-bottom: 0.625rem;
        font-size: 1.0625rem;
    }
}

/* Styling for custom option */
.custom-option {
    display: flex;
    align-items: center;
    padding: 5px 10px;
    cursor: pointer;
}
  
.custom-option:hover {
    background-color: #f0f0f0;
}

.custom-option-image {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    margin-right: 10px;
}

.css-hlgwow .css-19bb58m {
    display: flex;
    align-items: center;
}

.css-hlgwow .css-19bb58m img {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    margin-right: 10px;
}

/* .css-b62m3t-container{
    @apply w-fit
} */
/* Styling only the border of the select field */
.css-b62m3t-container .css-13cymwt-control {
    border-radius: 0.75rem;
    border-color: ;
    padding: 0.25rem;
    font-size: 1rem;
    font-weight: 500;
    color: ;
}
@media (min-width: 1400px) {

    .css-b62m3t-container .css-13cymwt-control {
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
        font-size: 1.0625rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/input.css"],"names":[],"mappings":";;AAGI;IAAA,oBAAqC;IAArC,gBAAqC;IAArC,oBAAqC;IAArC;AAAqC;;AAIrC;IAAA,oBAA6M;IAA7M,WAA6M;IAA7M,qBAA6M;IAA7M,iBAA6M;IAA7M,sBAA6M;IAA7M,4DAA6M;IAA7M,kBAA6M;IAA7M,mBAA6M;IAA7M,mBAA6M;IAA7M,sBAA6M;IAA7M,oBAA6M;IAA7M,gBAA6M;IAA7M,OAA6M;IAA7M,wJAA6M;IAA7M,wDAA6M;IAA7M;AAA6M;;AAA7M;IAAA,cAA6M;IAA7M,8BAA6M;IAA7M;AAA6M;;AAA7M;;IAAA;QAAA,sBAA6M;QAA7M,uBAA6M;QAA7M,mBAA6M;QAA7M;IAA6M;AAAA;;AAGjN,sBAAsB;AAElB;IAAA,sBAA8M;IAA9M,iBAA8M;IAA9M,sBAA8M;IAA9M,4DAA8M;IAA9M,mBAA8M;IAA9M,sBAA8M;IAA9M,0BAA8M;IAA9M,eAA8M;IAA9M,gBAA8M;IAA9M,OAA8M;IAA9M,wJAA8M;IAA9M,wDAA8M;IAA9M;AAA8M;AAA9M;IAAA,cAA8M;IAA9M;AAA8M;AAA9M;;IAAA;QAAA,sBAA8M;QAA9M,iBAA8M;QAA9M,qBAA8M;QAA9M,wBAA8M;QAA9M;IAA8M;AAAA;;AAI9M;IAAA,uBAAwE;IAAxE,sBAAwE;IAAxE,4DAAwE;IAAxE,sBAAwE;IAAxE,oBAAwE;IAAxE,gBAAwE;IAAxE,oBAAwE;IAAxE;AAAwE;;AAIxE;IAAA,cAAyM;IAAzM,WAAyM;IAAzM,qBAAyM;IAAzM,iBAAyM;IAAzM,sBAAyM;IAAzM,4DAAyM;IAAzM,gBAAyM;IAAzM,0BAAyM;IAAzM,oBAAyM;IAAzM,gBAAyM;IAAzM,OAAyM;IAAzM,wJAAyM;IAAzM,wDAAyM;IAAzM;AAAyM;;AAAzM;IAAA,cAAyM;IAAzM;AAAyM;;AAAzM;;IAAA;QAAA,sBAAyM;QAAzM,aAAyM;QAAzM;IAAyM;AAAA;;AAIzM;IAAA,oBAAqC;IAArC,gBAAqC;IAArC,oBAAqC;IAArC;AAAqC;;AAIrC;IAAA,eAAgG;IAAhG,cAAgG;IAAhG,eAAgG;IAAhG,uBAAgG;IAAhG,iBAAgG;IAAhG,cAAgG;IAAhG;AAAgG;;AAAhG;;IAAA;QAAA,cAAgG;QAAhG;IAAgG;AAAA;;AAIhG;IAAA,oBAAoF;IAApF,kBAAoF;IAApF,QAAoF;IAApF,WAAoF;IAApF,uBAAoF;IAApF,aAAoF;IAApF,mBAAoF;IAApF;AAAoF;;AAApF;;IAAA;QAAA;IAAoF;AAAA;;AAIpF;IAAA,sBAAgC;IAAhC;AAAgC;;AAAhC;;IAAA;QAAA;IAAgC;AAAA;;AAIhC;IAAA,qBAAiE;IAAjE,iBAAiE;IAAjE,sBAAiE;IAAjE;AAAiE;;AAAjE;;IAAA;QAAA,sBAAiE;QAAjE;IAAiE;AAAA;;AAIjE;IAAA,mBAAgC;IAAhC,gBAAgC;IAAhC,oBAAgC;IAAhC;AAAgC;;AAIhC;IAAA,kBAAkD;IAAlD,QAAkD;IAAlD,WAAkD;IAAlD,cAAkD;IAAlD,aAAkD;IAAlD;AAAkD;;AAIlD;IAAA,cAA6O;IAA7O,WAA6O;IAA7O,uBAA6O;IAA7O,uBAA6O;IAA7O,cAA6O;IAA7O,kBAA6O;IAA7O,4DAA6O;IAA7O,eAA6O;IAA7O,6BAA6O;IAA7O,oBAA6O;IAA7O,gBAA6O;IAA7O;AAA6O;;AAA7O;IAAA;AAA6O;;AAA7O;IAAA,cAA6O;IAA7O,8BAA6O;IAA7O,mBAA6O;IAA7O;AAA6O;;AAA7O;;IAAA;QAAA,sBAA6O;QAA7O,iBAA6O;QAA7O;IAA6O;AAAA;;AAI7O;IAAA,eAAqM;IAArM,uBAAqM;IAArM,uBAAqM;IAArM,sBAAqM;IAArM,4DAAqM;IAArM,kBAAqM;IAArM,mBAAqM;IAArM,mBAAqM;IAArM,sBAAqM;IAArM,mBAAqM;IAArM,gBAAqM;IAArM,oBAAqM;IAArM,iDAAqM;IAArM,wJAAqM;IAArM,wDAAqM;IAArM;AAAqM;;AAArM;IAAA,sBAAqM;IAArM,sDAAqM;IAArM,oBAAqM;IAArM;AAAqM;;AAArM;;IAAA;QAAA,iBAAqM;QAArM,qBAAqM;QAArM,wBAAqM;QAArM;IAAqM;AAAA;;AAGzM,8BAA8B;AAC9B;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;;GAEG;AACH,gDAAgD;AAE5C;IAAA,sBAA4F;IAA5F,cAA4F;IAA5F,gBAA4F;IAA5F,eAA4F;IAA5F,gBAA4F;IAA5F;AAA4F;AAA5F;;IAAA;QAAA,mBAA4F;QAA5F,sBAA4F;QAA5F;IAA4F;AAAA","sourcesContent":["\n\n.input-label {\n    @apply text-darkGrayClr font-7 text-17\n}\n\n.input-field {\n    @apply  w-full mt-0.5 px-4 py-2 xxl:py-2 font-5 text-17 text-lightGrayClr border xxl:border-1 border-dullTextClr rounded-lg xxl:rounded-xl  focus:border-primaryClr focus:outline-none transition duration-300\n}\n\n/* date picker input */\n.input-date-field {\n    @apply ps-4 py-2 xxl:py-2.5 font-5 text-16 xxl:text-17 text-lightGrayClr border xxl:border-2 border-dullTextClr rounded-xl xxl:rounded-xl focus:ring-primaryClr focus:border-primaryClr transition duration-300\n}\n\n.input-prefix-content {\n    @apply font-5 text-17 pr-3 border-r-2 text-darkGrayClr border-dullTextClr\n}\n\n.input-with-prefix {\n    @apply block w-full ps-20 xxl:ps-20 p-3 xxl:p-4 font-5 text-17 text-lightGrayClr transition duration-300 border border-dullTextClr rounded-lg xxl:rounded-xl focus:ring-primaryClr focus:border-primaryClr\n}\n\n.checkbox-label {\n    @apply text-darkGrayClr font-6 text-17\n}\n\n.checkbox {\n    @apply w-5 h-5 xxl:w-6 xxl:h-6 bg-primaryClr rounded-md cursor-pointer border-2 border-outlineClr\n}\n\n.prefix-icon {\n    @apply absolute inset-y-0 start-0 flex items-center ps-5 xxl:ps-6 pointer-events-none\n}\n\n.input-error {\n    @apply border-redClr xxl:border-2\n}\n\n.input-prefix-error {\n    @apply border-redClr border xxl:border-2 rounded-lg xxl:rounded-xl\n}\n\n.error-msg {\n    @apply text-redClr font-6 text-13\n}\n\n.input-suffix {\n    @apply absolute inset-y-0 right-3 flex items-center\n}\n\n.search-input {\n    @apply block ps-11 xxl:ps-14 p-2 font-6 text-17 border-1 xxl:border-2 w-full border-outlineClr rounded-10 xxl:rounded-xl bg-white tracking-wide placeholder:text-lightGrayClr focus:ring-primaryClr focus:outline-none focus:border-primaryClr\n}\n\n.select-field {\n    @apply px-4 py-2 xxl:py-2.5 font-5 text-15 xxl:text-17 text-darkGrayClr border-1 xxl:border-2 border-dullTextClr rounded-10 focus:ring-black focus:border-black cursor-pointer transition duration-300\n}\n\n/* Styling for custom option */\n.custom-option {\n    display: flex;\n    align-items: center;\n    padding: 5px 10px;\n    cursor: pointer;\n}\n  \n.custom-option:hover {\n    background-color: #f0f0f0;\n}\n\n.custom-option-image {\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n    margin-right: 10px;\n}\n\n.css-hlgwow .css-19bb58m {\n    display: flex;\n    align-items: center;\n}\n\n.css-hlgwow .css-19bb58m img {\n    width: 25px;\n    height: 25px;\n    border-radius: 50%;\n    margin-right: 10px;\n}\n\n/* .css-b62m3t-container{\n    @apply w-fit\n} */\n/* Styling only the border of the select field */\n.css-b62m3t-container .css-13cymwt-control {\n    @apply p-1 xxl:py-2 font-5 text-16 xxl:text-17 text-lightGrayClr border-outlineClr rounded-xl\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
